module.exports = __webpack_public_path__ + "static/media/Niveau_elN0_2_166982.26dad8b5.png";